<template>
  <div>
    <div class="pa-3 social-wrapper d-align d-just-space p-rlvw">
      <share-network
        v-for="network in networks"
        :network="network.network"
        :key="network.network"
        :title="network.quote"
        :url="network.url"
        :quote="network.quote"
        :hashtags="network.hashtags"
      >
        <div>
          <img :src="network.imgSrc" alt />
        </div>
      </share-network>
      <div class="cursor" @click="copyLink()">
        <img src="../../../public/img/avatars/link.png" alt="Network Images" />
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config.js";

export default {
  props: ["type", "slug"],
  data() {
    return {
      shareNetworkLoader: false,
      isloader: true,
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          url:
            this.type === "cme"
              ? `${config.DOCSMART_URL}cme-events/${this.slug}`
              : this.type === "blog"
              ? `${config.DOCSMART_URL}blog/${
                  this.$route && this.$route.params && this.$route.params.slug
                }`
              : `${config.DOCSMART_URL}${this.$route.fullPath.substring(1)}`,
          title: "",
          quote: "",
          hashtags: "",
          imgSrc: require(`../../../public/img/avatars/facebook.png`),
          imgAlt: "Facebook",
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          url:
            this.type === "cme"
              ? `${config.DOCSMART_URL}cme-events/${this.slug}`
              : this.type === "blog"
              ? `${config.DOCSMART_URL}blog/${
                  this.$route && this.$route.params && this.$route.params.slug
                }`
              : `${config.DOCSMART_URL}${this.$route.fullPath.substring(1)}`,
          quote: "",
          hashtags: "",
          imgAlt: "Whatsapp",
          imgSrc: require(`../../../public/img/avatars/whatsapp.png`),
        },
        {
          network: "twitter",
          name: "Twitter",
          url:
            this.type === "cme"
              ? `${config.DOCSMART_URL}cme-events/${this.slug}`
              : this.type === "blog"
              ? `${config.DOCSMART_URL}blog/${
                  this.$route && this.$route.params && this.$route.params.slug
                }`
              : `${config.DOCSMART_URL}${this.$route.fullPath.substring(1)}`,
          quote: "",
          hashtags: "",
          imgAlt: "Twitter",
          imgSrc: require(`../../../public/img/avatars/twitter.png`),
        },
        {
          network: "email",
          name: "Email",
          url:
            this.type === "cme"
              ? `${config.DOCSMART_URL}cme-events/${this.slug}`
              : this.type === "blog"
              ? `${config.DOCSMART_URL}blog/${
                  this.$route && this.$route.params && this.$route.params.slug
                }`
              : `${config.DOCSMART_URL}${this.$route.fullPath.substring(1)}`,
          quote: "",
          imgAlt: "Gmail",
          imgSrc: require(`../../../public/img/avatars/mail.svg`),
        },
      ],

      linkUrl: "",
    };
  },

  mounted() {
    this.isloader = false;
  },

  methods: {
    copyLink() {
      if (this.type === "cme") {
        this.linkUrl = `${config.DOCSMART_URL}cme-events/${this.slug}`;
      } else if (this.type === "blog") {
        this.linkUrl = `${config.DOCSMART_URL}blog/${
          this.$route && this.$route.params && this.$route.params.slug
        }`;
      } else {
        this.linkUrl = `${config.DOCSMART_URL}${this.$route.fullPath.substring(
          1
        )}`;
      }
      navigator.clipboard.writeText(this.linkUrl);
      this.$swal.fire({
        toast: true,
        html: "<p> <b>" + "Link Copied" + "</b></p>",
        showCancelButton: false,
        showConfirmButton: false,
        position: "bottom",
        customClass: "bottom-swal",
        timer: 6000,
      });
    },
  },
};
</script>
<style lang="scss">
.social-wrapper {
  a {
    background-color: transparent !important;
  }
}
</style>